import * as React from "react";
import {useState} from 'react';
import { toast } from "../../utils";
import Modal from "../core/Modal"
import useQuote from '../../hooks/useQuote'



function QuickAddProduct(props){
  const [productName, setProductName] = useState('')
  const [productQty, setProductQty] = useState('')
  const [productCost, setProductCost] = useState('')
  const [productSale, setProductSale] = useState('')
  const [productCategory, setProductCategory] = useState('')
  const { 
    addingProduct, 
    setAddingProduct,
    allCategories 
  } = useQuote()

  function addProduct(){
    const category = allCategories.filter((category) => category.id == +productCategory)[0]
    let pcs_clone = props.productCategories
    if(category.name in pcs_clone){
      pcs_clone[category.name].push(
        {
          "id": null,
          "name": productName,
          "cost_price": productCost,
          "sale_price": productSale,
          "margin": "0",
          "quote_calculator_category_id": category.id,
          "category_name": category.name,
          "qty": productQty,
          "total": "0",
          "notes": ""
        }
      )
    }
    else{
      pcs_clone[category.name] = [
        {
          "id": null,
          "name": productName,
          "cost_price": productCost,
          "sale_price": productSale,
          "margin": "0",
          "quote_calculator_category_id": category.id,
          "category_name": category.name,
          "qty": productQty,
          "total": "0",
          "notes": ""
        }
      ]
    }
    props.setProducts(pcs_clone)
    setAddingProduct(false)
    toast.success('product has been added')
  }

  return (
    <Modal
    title={"Add Quote Specific Product"}
    open={addingProduct}
    close={() => setAddingProduct(false)}
    submittable={true}
    isLarge={false}
    disallowClickOutside={true}
    submitText="Add"
    onSubmit={addProduct}
  >
    <div className="row">
      <div className="col-lg-9">
        <div className="form-group">
          <label>Name</label>
          <input onChange={(e) => setProductName(e.target.value)} value={productName} type="text" className="form-control" placeholder="New Product" />
        </div>
        <div className="form-group">
          <label>Qty</label>
          <input onChange={(e) => setProductQty(e.target.value)} value={productQty} type="text" className="form-control" placeholder="0" />
        </div>
        <div className="form-group">
          <label>Cost</label>
          <input onChange={(e) => setProductCost(e.target.value)} value={productCost} type="text" className="form-control" placeholder="1.00" />
        </div>
        <div className="form-group">
          <label>Sale Price</label>
          <input onChange={(e) => setProductSale(e.target.value)} value={productSale} type="text" className="form-control" placeholder="2.00" />
        </div>
        <div className="form-group">
          <label>Select Category</label>
          <select className="form-control" value={productCategory} onChange={(e) => setProductCategory(e.target.value) }>
            <option value=''>Select One</option>
            {allCategories.map((category) => {
              return (
                <option value={category.id} key={category.id}>{category.name}</option>
              )
            })}
          </select>
        </div>
      </div>
    </div>
  </Modal>
  )
}


export default QuickAddProduct


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuickAddProduct.tsx